import axios from 'axios';
import { instance, objectToParams } from './api';

const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;

export const checkUser = () => JSON.parse(localStorage.getItem('user'));

export const currentRole = () => {
  const { currentRole } = connectStore();
  return currentRole ? currentRole : null;
};

export const currentToken = () => {
  const { token } = connectStore();
  return token ? token : null;
};

const connectStore = () => {
  const userString = localStorage.getItem('user');
  return userString ? JSON.parse(userString) : {};
};

export const login = (creds) => axios.post(`${ENDPOINT}/login`, creds);

export const getUserStatus = () => instance.get(`/api/v1/status`);

export const listUsers = (args) => instance.get(`/api/v1/users?${objectToParams(args)}`);

export const signUp = (form) => instance.post(`/api/v1/users`, form);

export const deleteUser = (id) => instance.delete(`/api/v1/users/${id}`);

export const getUserId = (id) => instance.get(`/api/v1/users/${id}`);

export const editUserId = (id, data) => instance.put(`/api/v1/users/${id}`, data);
